// src/pages/Contact.jsx
import React, { useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';

function Contact() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Your EmailJS credentials
  const serviceID  = 'service_ub8mjrw';
  const templateID = 'template_91b3irb';
  const publicKey = 'zfNcS6aODlCdmmPQv';

  // Initialize EmailJS with your public key
  useEffect(() => {
    emailjs.init(publicKey);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(false);

    // Create a title from the first few words of the message
    const messageTitle = form.message.split(' ').slice(0, 5).join(' ') + '...';

    // Template parameters matching your EmailJS template
    const templateParams = {
      name: form.name,          // {{name}} in your template
      email: form.email,        // {{email}} for reply-to
      message: form.message,    // {{message}} for the actual message
      title: messageTitle,      // {{title}} for the subject line
    };

    try {
      const response = await emailjs.send(
        serviceID,
        templateID,
        templateParams,
        publicKey
      );
      
      console.log('SUCCESS!', response.status, response.text);
      setSubmitted(true);
      setError(false);
      setForm({ name: '', email: '', message: '' });
      
      // Hide success message after 5 seconds
      setTimeout(() => setSubmitted(false), 5000);
    } catch (err) {
      console.error('FAILED...', err);
      setError(true);
      
      // Log more detailed error information
      if (err.text) {
        console.error('Error details:', err.text);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="contact">
      <div className="contact__container">
        <div className="contact__header">
          <span className="contact__subtitle">Get In Touch</span>
          <h1 className="contact__title">Contact Me</h1>
          <div className="contact__divider" />
        </div>

        {submitted && (
          <div className="contact__success">
            <span>✅</span>
            <p>Thank you! I'll respond as soon as possible.</p>
          </div>
        )}
        
        {error && (
          <div className="contact__error">
            <span>❌</span>
            <p>Oops! Something went wrong. Please try again later.</p>
          </div>
        )}

        <form className="contact__form" onSubmit={handleSubmit}>
          <div className="contact__field">
            <label htmlFor="name">Full Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={form.name}
              onChange={handleChange}
              required
              placeholder="John Doe"
              disabled={isLoading}
            />
          </div>

          <div className="contact__field">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              required
              placeholder="john@example.com"
              disabled={isLoading}
            />
          </div>

          <div className="contact__field">
            <label htmlFor="message">Your Message</label>
            <textarea
              id="message"
              name="message"
              value={form.message}
              onChange={handleChange}
              required
              placeholder="Let's discuss how I can contribute to your team..."
              rows={5}
              disabled={isLoading}
            />
          </div>

          <button 
            type="submit" 
            className="contact__submit"
            disabled={isLoading}
          >
            {isLoading ? 'Sending...' : 'Send Message'}
          </button>
        </form>
      </div>
    </section>
  );
}

export default Contact;